angular
  .module(__filename, [
    'ui.router',

    require('./list').default,
    require('./show').default,

    require('goodeggs-purchase-orders-sdk/catalog/angular_resource'),
    require('goodeggs-purchase-orders-sdk/procurement_schedule/angular_resource'),
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('procurement_schedules', {
        url: '/procurement_schedules',
        parent: 'foodhub',
        abstract: true,
        data: {pageTitle: 'Procurement Schedules'},
        template: require('./template'),
      }),
    ),
  );

export default __filename;
